// extracted by mini-css-extract-plugin
export default {"promo":"Promo_promo__SRLyg","background":"Promo_background__ku4kK","logo":"Promo_logo__faNCz"};